/* unplugin-vue-components disabled */import { render } from "./AssetsCard.vue?vue&type=template&id=33ad6173&scoped=true"
import script from "./AssetsCard.vue?vue&type=script&lang=js"
export * from "./AssetsCard.vue?vue&type=script&lang=js"

import "./AssetsCard.vue?vue&type=style&index=0&id=33ad6173&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ad6173"]])

export default __exports__